import styled from 'styled-components';

export default styled.aside`
	--sticky-footer: var(--px-84);
	height: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
	.customScrollbar {
		height: 100%;
		display: flex;
		flex-direction: column;
	}
	.hide-content {
		display: none;
	}
`;
